import { render, staticRenderFns } from "./QaCategorySelect.vue?vue&type=template&id=0271cfa7&scoped=true&"
import script from "./QaCategorySelect.vue?vue&type=script&lang=js&"
export * from "./QaCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./QaCategorySelect.vue?vue&type=style&index=0&id=0271cfa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271cfa7",
  null
  
)

export default component.exports